// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3Sa4P","info":"Note_info__1Gtc3","note":"Note_note__ZkEgt","actions":"Note_actions__1btIR"};